module.exports = __webpack_public_path__ + "img/pt18.85cf2498.png";